import { c as _c } from "react/compiler-runtime";
import { cx } from '../styles/stylebook';
const GridLayout = t0 => {
  const $ = _c(14);
  let children;
  let props;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      children,
      cols: t1,
      className: t2,
      noPadding: t3,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    children = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const cols = t1 === undefined ? 12 : t1;
  const className = t2 === undefined ? "" : t2;
  const noPadding = t3 === undefined ? false : t3;
  const getGridCols = _temp;
  const t4 = noPadding ? "" : "px-marg";
  let t5;
  if ($[6] !== className || $[7] !== cols || $[8] !== t4) {
    t5 = cx("gap-gutter grid", t4, getGridCols(cols), className);
    $[6] = className;
    $[7] = cols;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== children || $[11] !== props || $[12] !== t5) {
    t6 = <div className={t5} {...props}>{children}</div>;
    $[10] = children;
    $[11] = props;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
};
export const GridItem = t0 => {
  const $ = _c(6);
  const {
    children,
    className: t1,
    cols: t2
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const cols = t2 === undefined ? 12 : t2;
  const getColSpan = _temp2;
  let t3;
  if ($[0] !== className || $[1] !== cols) {
    t3 = cx(getColSpan(cols), className);
    $[0] = className;
    $[1] = cols;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default GridLayout;
function _temp(cols_0) {
  switch (cols_0) {
    case 12:
      {
        return "grid-cols-12 max-md:grid-cols-6";
      }
    case 9:
      {
        return "grid-cols-9 max-md:grid-cols-6";
      }
    case 6:
      {
        return "grid-cols-6 max-md:grid-cols-3";
      }
    case 4:
      {
        return "grid-cols-4 max-md:grid-cols-2";
      }
    case 3:
      {
        return "grid-cols-3 max-md:grid-cols-1";
      }
    case 2:
      {
        return "grid-cols-2 max-md:grid-cols-1";
      }
    case 1:
      {
        return "grid-cols-1";
      }
    case 5:
      {
        return "grid-cols-5 max-md:grid-cols-2";
      }
    case 10:
      {
        return "grid-cols-10 max-md:grid-cols-5";
      }
    default:
      {
        return "grid-cols-12 max-md:grid-cols-6";
      }
  }
}
function _temp2(cols_0) {
  switch (cols_0) {
    case 12:
      {
        return "col-span-12 max-md:col-span-6";
      }
    case 9:
      {
        return "col-span-9 max-md:col-span-6";
      }
    case 6:
      {
        return "col-span-6 max-md:col-span-3";
      }
    case 4:
      {
        return "col-span-4 max-md:col-span-2";
      }
    case 3:
      {
        return "col-span-3 max-md:col-span-1";
      }
    case 2:
      {
        return "col-span-2 max-md:col-span-1";
      }
    case 1:
      {
        return "col-span-1";
      }
    case 5:
      {
        return "col-span-5 max-md:col-span-6";
      }
    case 10:
      {
        return "col-span-10 max-md:col-span-6";
      }
    default:
      {
        return "col-span-12 max-md:col-span-6";
      }
  }
}